import dayjs from '@/plugins/dayjs';

export const toDate = (value: string): Date | null => {
  if (!value) {
    return null;
  }

  return dayjs(value).toDate();
};
